import * as actionTypes from "./actionTypes";

export const loadedGroups = (userGroups, askedGroups, groupInvites) => ({
    type: actionTypes.LOADED_USER_GROUPS,
    userGroups,
    askedGroups,
    groupInvites
});

export const updateLoadedGroup = (group) => ({
    type: actionTypes.UPDATE_LOADED_GROUP,
    group
})

export const deletedGroup = (group) => ({
   type: actionTypes.DELETED_GROUP,
   group
});

export const addNewGroup = (group) => ({
    type: actionTypes.ADDED_USER_GROUP,
    group
})

export const askedNewGroup = (askedGroup) => ({
    type: actionTypes.ASKED_NEW_GROUP,
    askedGroup
})

export const groupSearchCompleted = (data) => ({
    type: actionTypes.LOADED_GROUP_SEARCH,
    data
})

export const groupSearchNewPageLoaded = (data) => ({
    type: actionTypes.NEW_PAGE_GROUP_SEARCH,
    data
})

export const updateSearchedGroup = (group) => ({
    type: actionTypes.UPDATE_SEARCHED_GROUP,
    group
})

export const setInviteDetails = (groups) => ({
    type: actionTypes.ADD_NEW_INVITE,
    groups
})

export const deleteInvite = (group) => ({
    type: actionTypes.DELETE_INVITE,
    group
})
